import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";
import { formatApiErrorDetail } from "./adminApi";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back.");
      navigate("/admin/projects");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[100dvh] bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-sm" data-testid="admin-login">
        <div className="w-12 h-12 rounded-full border border-[#FF2A2A]/40 flex items-center justify-center mb-8">
          <Lock className="w-5 h-5 text-[#FF2A2A]" />
        </div>
        <p className="font-mono-x text-[11px] tracking-[0.4em] text-[#737373] uppercase mb-2">
          FANLY · Studio
        </p>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter mb-8">Sign in</h1>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="font-mono-x text-[11px] tracking-widest uppercase text-[#737373]">
              Email
            </label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b-2 border-white/25 focus:border-[#FF2A2A] outline-none py-3 text-lg text-white placeholder:text-white/30 transition-colors"
              placeholder="you@artist.com"
            />
          </div>
          <div>
            <label className="font-mono-x text-[11px] tracking-widest uppercase text-[#737373]">
              Password
            </label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b-2 border-white/25 focus:border-[#FF2A2A] outline-none py-3 text-lg text-white placeholder:text-white/30 transition-colors"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={busy}
            className="w-full flex items-center justify-center gap-2 bg-white text-black font-semibold rounded-full py-4 hover:scale-[1.02] active:scale-95 transition-transform disabled:opacity-60"
          >
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "ENTER STUDIO"}
          </button>
        </form>
      </div>
    </div>
  );
}
